import { createFileRoute } from "@tanstack/react-router";
import { zodResolver } from "mantine-form-zod-resolver";
import {
    createDefaultIpawsAlertFormState,
    IpawsAlertFormProvider,
    ipawsAlertFormSteppedStateSchema,
    useIpawsAlertForm,
} from "shared/components/ipaws/alert/context";
import { IpawsTemplateFormLayout } from "shared/components/ipaws/template/IpawsTemplateFormLayout";
import { usePermissionCheck } from "shared/stores/oidc";
import { NoMessagesFigure } from "src/assets/NoMessagesFigure";
import { Permission } from "src/gql/graphql";

const Page = () => {
    const hasIpawsView = usePermissionCheck(Permission.IpawsAlertModify);
    if (!hasIpawsView) return <NoMessagesFigure>You do not have permission to view this page</NoMessagesFigure>;

    const form = useIpawsAlertForm({
        cascadeUpdates: true,
        initialValues: createDefaultIpawsAlertFormState(),
        validate: zodResolver(ipawsAlertFormSteppedStateSchema),
    });

    return (
        <IpawsAlertFormProvider form={form}>
            <IpawsTemplateFormLayout draftId="new" />
        </IpawsAlertFormProvider>
    );
};

/** @public */
export const Route = createFileRoute("/_auth/ipaws/templates/new")({
    component: Page,
});
